import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import PropTypes from 'prop-types';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { jsx as _jsx } from "react/jsx-runtime";
const UrlInput = ({
  disabled,
  errorKey,
  onChange,
  value
}) => {
  return /*#__PURE__*/_jsx(FormControl, {
    error: Boolean(errorKey),
    help: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'knowledgeContentUI.importModal.helpMessage'
    }),
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'knowledgeContentUI.importModal.urlInput.label'
    }),
    validationMessage: errorKey && /*#__PURE__*/_jsx(FormattedMessage, {
      message: errorKey
    }),
    marginBlockStart: "400",
    children: /*#__PURE__*/_jsx(TextInput, {
      disabled: disabled,
      name: "urlInput",
      onChange: onChange,
      placeholder: I18n.text('knowledgeContentUI.importModal.urlInput.placeholder'),
      value: value
    })
  });
};
UrlInput.propTypes = {
  disabled: PropTypes.bool.isRequired,
  errorKey: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
};
export default UrlInput;